import { render, staticRenderFns } from "./TechnicalSpecs.vue?vue&type=template&id=473fd5c6&scoped=true"
import script from "./TechnicalSpecs.vue?vue&type=script&lang=js"
export * from "./TechnicalSpecs.vue?vue&type=script&lang=js"
import style0 from "./TechnicalSpecs.vue?vue&type=style&index=0&id=473fd5c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473fd5c6",
  null
  
)

export default component.exports